enum InspectionTaskStatus {
    None,
    OK,
    NeedsAttention,
    NeedsRepair,
    NotApplicable,
}

export default InspectionTaskStatus;
